var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { isShopSessionView, useSession } from 'frontend/js/modules/infra/session';
import { useApiQuery } from 'frontend/js/modules/infra/api';
import { t } from '../../../../../../infra/i18n';
import { CreatorFilterDropdownContainer as CreatorFilterDropdown } from './creator-filter';
import { endpoints } from '../../../../network';
export var CreatorFilterDropdownContainer = function (_a) {
    var _b, _c;
    var creatorFilter = _a.creatorFilter, setCreatorFilter = _a.setCreatorFilter;
    var session = useSession().data;
    var shopId = (_c = (_b = (session === null || session === void 0 ? void 0 : session.view).viewer) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : '';
    var _d = useState([]), creators = _d[0], setCreators = _d[1];
    var _e = useApiQuery({
        endpoint: endpoints.campaignCreatorsFilterQuery,
        payload: {
            shopId: shopId,
        },
    }), creatorsByApiQuery = _e.data, isLoadingCreators = _e.isLoading;
    useEffect(function () {
        var _a;
        if (creatorsByApiQuery) {
            setCreators((_a = creatorsByApiQuery.ownerFilters) === null || _a === void 0 ? void 0 : _a.sort(function (a, b) { return a.firstName.localeCompare(b.firstName); }));
        }
    }, [creatorsByApiQuery]);
    if (!(isShopSessionView(session.view) && creators.length && !isLoadingCreators)) {
        return null;
    }
    var label = creatorFilter.length > 0
        ? "".concat(creatorFilter.length, " ").concat(creatorFilter.length === 1 ? t('engage:filters.creator') : t('engage:filters.creators'))
        : t('engage:filters.all_creators');
    var handleCreatorFilter = function (id, value) {
        if (value) {
            setCreatorFilter(__spreadArray(__spreadArray([], creatorFilter, true), [id], false));
        }
        else {
            setCreatorFilter(creatorFilter.filter(function (creatorId) { return creatorId !== id; }));
        }
    };
    var sortedCreators = creators.sort(function (a, b) {
        if (a.type !== b.type)
            return a.type === 'shop' ? -1 : 1;
        var aName = "".concat(a.firstName, " ").concat(a.lastName);
        var bName = "".concat(b.firstName, " ").concat(b.lastName);
        return aName.localeCompare(bName);
    });
    return (_jsx(CreatorFilterDropdown, { label: label, creatorFilter: creatorFilter, setCreatorFilter: handleCreatorFilter, creators: sortedCreators }));
};
